import React from 'react';
import Button from '../Button';
import {Box} from '../../foundations';
import {SxProps, Theme, Typography} from '@mui/material';
import Image from 'next/image';
import {AppleLogo} from '../../assets/icons';

type AppleButtonProps = {
  onClick: () => void;
  disabled?: boolean;
  text?: string;
  sx?: SxProps<Theme>;
};

const AppleButton: React.FC<AppleButtonProps> = ({
  onClick,
  disabled,
  text = 'Continue with Apple',
  sx,
}) => {
  return (
    <Button
      variant="outlined"
      onClick={onClick}
      disabled={disabled}
      sx={sx as any}
    >
      <Box sx={{display: 'flex', alignItems: 'center', gap: '10px'}}>
        <Image src={AppleLogo} alt="Apple" width={20} height={20} />
        <Typography style={{color: '#111111'}}>{text}</Typography>
      </Box>
    </Button>
  );
};

export default AppleButton;
